import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import { FETCH_TAILOR_MADE_TOUR, FETCH_TAILOR_MADE_TOUR_ORDER, FETCH_TOUR_OPERATORS, FETCH_TOUR_SEARCH_FACETS, SET_TOUR_PRICE_MODE } from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'

export const initialTourState: App.TourState = {
  tourFacets: {},
  tourOperators: {},
  tailorMadeTour: { initial: true },
  tailorMadeTourOrders: {},
  tourPriceMode: 'total',
}

const apiCalls = apiReducerSwitch<App.TourState>({
  [FETCH_TOUR_SEARCH_FACETS]: {
    request: (state, action) => ({
      tourFacets: {
        ...state.tourFacets,
        [action.key]: {
          fetching: true,
        },
      },
    }),
    success: (state, action) => ({
      tourFacets: {
        ...state.tourFacets,
        [action.key]: {
          data: action.data,
          fetching: false,
        },
      },
    }),
    failure: (state, action) => ({
      tourFacets: {
        ...state.tourFacets,
        [action.key]: {
          error: action.error,
          fetching: false,
        },
      },
    }),
  },
  [FETCH_TOUR_OPERATORS]: {
    request: (state) => ({
      tourOperators: {
        ...state.tourOperators,
        operators: {},
        fetching: true,
      },
    }),
    success: (state, action) => ({
      tourOperators: {
        ...state.tourOperators,
        operators: { ...action.data },
        fetching: false,
      },
    }),
    failure: (state, action) => ({
      tourOperators: {
        ...state.tourOperators,
        operators: {},
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_TAILOR_MADE_TOUR]: {
    request: () => {
      return {
        tailorMadeTour: { fetching: true },
      }
    },
    success: (_state, action) => {
      return {
        tailorMadeTour: { fetching: false, data: action.data },
      }
    },
    failure: (state, action) => {
      return {
        tailorMadeTour: { fetching: false, error: action.error },
      }
    },
  },
  [FETCH_TAILOR_MADE_TOUR_ORDER]: {
    request: (state, action) => {
      return {
        tailorMadeTourOrders: {
          ...state.tailorMadeTourOrders,
          [action.tailorMadeTourRequestId]: { fetching: true },
        },
      }
    },
    success: (state, action) => {
      return {
        tailorMadeTourOrders: {
          ...state.tailorMadeTourOrders,
          [action.tailorMadeTourRequestId]: { fetching: false, data: action.data },
        },
      }
    },
    failure: (state, action) => {
      return {
        tailorMadeTourOrders: {
          ...state.tailorMadeTourOrders,
          [action.tailorMadeTourRequestId]: {
            fetching: false,
            error: String(action.error),
          },
        },
      }
    },
  },
})

export default createAppReducer<App.TourState>(initialTourState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [SET_TOUR_PRICE_MODE]: (state, action) => ({
    ...state,
    tourPriceMode: action.tourPriceMode,
  }),
})
